import { auth, db } from './firebase/config';
import { doc, setDoc, collection, getDocs } from 'firebase/firestore';

/**
 * Function to set up the initial admin user and allowed emails
 * This should be run in the browser console after signing in
 */
const setupAdminUser = async () => {
  try {
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      console.error('No user is signed in. Please sign in first.');
      return {
        success: false,
        error: 'No user is signed in. Please sign in first.'
      };
    }
    
    // Only allow specific emails to become admin
    const adminEmails = ['nyanlinthu.education@gmail.com', 'nightmare.2231@gmail.com'];
    
    if (!adminEmails.includes(currentUser.email.toLowerCase())) {
      return {
        success: false,
        error: 'You are not authorized to become an admin.'
      };
    }
    
    // Set current user as admin in the users collection
    await setDoc(doc(db, 'users', currentUser.uid), {
      email: currentUser.email,
      displayName: currentUser.displayName || 'Admin User',
      isAdmin: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }, { merge: true });
    
    // Add current user's email to the allowedEmails collection
    await setDoc(doc(db, 'allowedEmails', currentUser.email.toLowerCase()), {
      addedBy: currentUser.email,
      addedAt: new Date().toISOString()
    });
    
    // Create adminSetup document to mark that admin has been initialized
    await setDoc(doc(db, 'adminSetup', 'initialized'), {
      initializedBy: currentUser.email,
      initializedAt: new Date().toISOString()
    });
    
    // Check if collections exist
    const usersSnapshot = await getDocs(collection(db, 'users'));
    const allowedEmailsSnapshot = await getDocs(collection(db, 'allowedEmails'));
    
    return {
      success: true,
      admin: currentUser.email,
      collections: {
        users: usersSnapshot.size,
        allowedEmails: allowedEmailsSnapshot.size
      }
    };
  } catch (error) {
    console.error('Error setting up admin user:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Make it accessible from the browser console safely but without logging
try {
  window.setupAdmin = setupAdminUser;
} catch (error) {
  // Silent fail
}

// Export for potential future imports
export default setupAdminUser; 